import { TGanttResource } from '../types/process';
import { getAttendanceList } from '../apicalls/attendanceManages';
import { checkResData } from './common';
import {
  convertToFullCalendarDateString,
  convertToFullCalendarEndDateString,
  convertToFullCalendarId,
  createGanttResourceAttendanceManage
} from './processGantChartUtils';

export const createGanttResourceAndEvent = async (
  constructId: number,
  enqueueSnackbar: any,
  searchStartDate?: string,
  searchEndDate?: string
) => {
  let ganttResourceList: Array<TGanttResource> = [];
  let ganttEventList: any[] = [];

  const resData = await getAttendanceList(
    constructId,
    searchStartDate,
    searchEndDate
  );
  const attendanceDataList = await checkResData(
    resData.attendance_manage_data_list,
    enqueueSnackbar
  );

  if (attendanceDataList) {
    // ガントのデータ作成
    ganttResourceList = attendanceDataList.map((attendanceData: any) => {
      return createGanttResourceAttendanceManage(attendanceData, false, null);
    });
    ganttEventList = [];
    attendanceDataList.map((attendanceData: any) => {
      const attendanceManageEventList =
        attendanceData.attendance_manage_event_list;

      attendanceManageEventList &&
        attendanceManageEventList.length > 0 &&
        attendanceManageEventList.map((attendanceManageEvent: any) => {
          const resourceId = convertToFullCalendarId(
            attendanceManageEvent.attendance_manage_id
          );
          ganttEventList.push({
            id: convertToFullCalendarId(attendanceManageEvent.id),
            title: convertToFullCalendarId(attendanceManageEvent.artificial),
            start: convertToFullCalendarDateString(
              attendanceManageEvent.target_date + ' 00:00:00'
            ),
            end: convertToFullCalendarEndDateString(
              attendanceManageEvent.target_date + ' 23:59:59'
            ),
            resourceIds: [resourceId],
            backgroundColor:
              attendanceData.business_type == 1 ? '#FFCC00' : 'blue',
            borderColor: attendanceData.business_type == 1 ? '#FFCC00' : 'blue',
            textColor: attendanceData.business_type == 1 ? 'black' : 'white',
            extendedProps: {
              // order: 'ユーザー名',
              priorityOrder: attendanceManageEvent.id,
              attendance: attendanceData
            }
          });
        });
    });
  }

  return {
    resources: ganttResourceList,
    events: ganttEventList,
    attendanceManageEventList: resData.attendance_manage_event_list
  };
};
